import React from 'react'

export const carouselContext = React.createContext<{
  wrapAround: boolean
  slideCount: number
  slidesToShow: number
  cellAlign: 'center' | 'right' | 'left'
  slidesToScroll: number
  currentSlide: number
  animationDistance: number
  disableAnimation: boolean
  speed: number
  frameHeight: string

  nextSlide(): void
  prevSlide(): void
  goToSlide(index: number): void

  slideContainerRef: React.RefObject<HTMLDivElement | null>
  slideViewpointRef: React.RefObject<HTMLDivElement | null>
  slides: any[]
  carouselId: string
  initializedAdaptiveHeight: boolean
  adaptiveHeight: boolean
  onVisibleSlideHeightChange: (index: number, height: number | null) => unknown
} | null>(null)

export function useCarouselContext() {
  const context = React.useContext(carouselContext)

  if (!context) {
    throw new Error('Cannot find carousel Context')
  }
  return context
}
